
import { Vue } from "vue-class-component";

export default class Footer extends Vue {}
